import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalElements: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    pageSize,
    totalElements,
    onPageChange,
    onPageSizeChange
}) => {
    const handlePrevious = () => {
        if (currentPage > 0) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages - 1) {
            onPageChange(currentPage + 1);
        }
    };

    return (
        <div className="pagination-container">
            <div className="pagination-info">
                <span>
                    Mostrando {currentPage * pageSize + 1} a{' '}
                    {Math.min((currentPage + 1) * pageSize, totalElements)} de {totalElements} totais
                </span>
            </div>
            <div className="pagination-controls">
                <select
                    className="page-size-select"
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                >
                    <option value={10}>10 </option>
                    <option value={20}>20</option>
                    <option value={50}>50 </option>
                    <option value={100}>100</option>
                </select>
                <button
                    className="pagination-button"
                    onClick={handlePrevious}
                    disabled={currentPage === 0}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <span className="page-number">
                    Página {currentPage + 1} de {totalPages || 1}
                </span>
                <button
                    className="pagination-button"
                    onClick={handleNext}
                    disabled={currentPage >= totalPages - 1}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
